import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
  TAKING_CAR_PURCHASE_SAVE_SUCCESS,
  TAKING_CAR_PURCHASE_SAVE_FAILURE
} from '../constants'

export function* saveTakingCarManagmentSaga({
  data: { id, actionCode, fields }
}) {
  try {
    const responseUpdateStateMachine = yield call(
      BFFAgent.Stock.TakingCarManagement.dispatchAction,
      id,
      actionCode,
      true,
      fields
    )

    if (responseUpdateStateMachine) {
      yield put({
        type: TAKING_CAR_PURCHASE_SAVE_SUCCESS,
        data: responseUpdateStateMachine
      })
    }
  } catch (error) {
    yield put({
      type: TAKING_CAR_PURCHASE_SAVE_FAILURE,
      data: { error }
    })
  }
}
